import React from 'react';
import { makeStyles } from '@material-ui/styles';
import TopAppBar from './TopAppBar';
import WarnningBox from './WarnningBox';

import theme from '../theme';
import { useImagePath } from '../hooks/paths';

const useStyles = makeStyles((theme) => ({

  containerPage:{
    //display: 'flex', 
    //justifyContent: 'center', 
    //alignItems: 'center', 
    width: "100vw", 
    height: "100vh",
  },


  containerFlex:{
    width: "100%",
    //marginTop: theme.spacing(2),
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
   //backgroundColor: "red",
  },

  containerInfo:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",
    padding: theme.spacing(2), 
    //marginTop: "10vh",
    fontSize: "1.3rem",
    textAlign: "center", 
    [theme.breakpoints.up('md')]: {
      width: "40%",
      padding:  theme.spacing(2),
    },
  },

  image:{
    width: "100%",
  },

  playButton:{
    height: "3rem",
    width: "auto",
    borderRadius: "0.5rem",
    boxShadow: theme.boxShadow.image,
    margin: theme.spacing(1)
  }

}));



export default function OpenTicketPage(props) {
  const classes = useStyles();
  const {strings} = props; 
 
  const urlPlay = "https://play.google.com/store/apps/details?id=com.campino.wikimenu&referrer=utm_source%3Dweb-default"
  const imagePath = useImagePath();
  const imageUrl =  `${imagePath}/google-play-badge.png`;
  const urlImage =  `${imagePath}/${strings.image_open_with}`;
  

  return (
    <div className = {classes.containerPage}>  
        <TopAppBar title = {strings.title_summary} />

          <div className = {classes.containerFlex}>
            <div className = {classes.containerInfo}>
                <img className ={classes.image} src={urlImage} alt={"ticket"}/>    
                <WarnningBox
                    message={strings.ticket_private_info}    
                    icon={false}   
                />
                <a  href ={urlPlay} target="_blank" rel="noreferrer noopener">
                <img className={classes.playButton} src={imageUrl} alt={"image"} />
                </a>
            </div>

          </div>
          
    </div>
  );
}
